
export function toDoIsSuggested(toDo) {
  return (
    toDo.toDoType === 'suggested'
  );
}
